<script lang="ts">
    // import src from '../../../assets/warning_FILL0_wght400_GRAD0_opsz24.svg';
    import src from './svg/Icon Alert.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    scale = scale * 0.8; // fix scale
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
